import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NationalParkService {

    currentParkPage: string;

    constructor() {
    }

    getCurrentParkPage() {
        return this.currentParkPage;
    }

    setCurrentParkPage(ParkPage: string, callback) {
        this.currentParkPage = ParkPage;
        callback.apply();
    }

    removeCurrentPageParkCube() {
        const cube = document.getElementById(this.currentParkPage + 'Cube');
        cube.parentNode.removeChild(cube);
    }
}
